(function () {
  'use strict';

  var STORAGE_PLAYED = 'invero_bj_played_v1';
  var STORAGE_SEEN = 'invero_bj_seen_v1';
  var DISCOUNT_CODE = 'BLACKJACK10';
  var TRIGGER_DELAY_MS = 4000;
  var SHOP_REDIRECT_PATH = '/collections/collection-001';

  function alreadyPlayed() {
    try {
      return !!localStorage.getItem(STORAGE_PLAYED);
    } catch (e) {
      return false;
    }
  }

  function markPlayed() {
    try {
      localStorage.setItem(STORAGE_PLAYED, '1');
    } catch (e) {}
  }

  function markSeen() {
    try {
      localStorage.setItem(STORAGE_SEEN, '1');
    } catch (e) {}
  }

  function hasSeen() {
    try {
      return !!localStorage.getItem(STORAGE_SEEN);
    } catch (e) {
      return false;
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var overlay = document.getElementById('bj-overlay');
    if (!overlay) return;

    var tab = document.getElementById('bj-tab');
    var closeBtn = document.getElementById('bj-close');

    var screens = {
      email: document.getElementById('bj-screen-email'),
      game: document.getElementById('bj-screen-game'),
      result: document.getElementById('bj-screen-result')
    };

    var emailForm = document.getElementById('bj-email-form');
    var emailInput = document.getElementById('bj-email-input');
    var consentInput = document.getElementById('bj-consent-input');
    var emailError = document.getElementById('bj-email-error');

    var dealerCardsEl = document.getElementById('bj-dealer-cards');
    var playerCardsEl = document.getElementById('bj-player-cards');
    var dealerScoreEl = document.getElementById('bj-dealer-score');
    var playerScoreEl = document.getElementById('bj-player-score');
    var hitBtn = document.getElementById('bj-hit');
    var standBtn = document.getElementById('bj-stand');

    var resultIcon = document.getElementById('bj-result-icon');
    var resultTitle = document.getElementById('bj-result-title');
    var resultSubtitle = document.getElementById('bj-result-subtitle');
    var codeBox = document.getElementById('bj-code-box');
    var codeText = document.getElementById('bj-code-text');
    var copyBtn = document.getElementById('bj-copy');
    var shopBtn = document.getElementById('bj-shop-btn');
    var continueBtn = document.getElementById('bj-continue-btn');

    if (alreadyPlayed()) {
      return; // one hand, no re-deal
    }

    function showScreen(name) {
      Object.keys(screens).forEach(function (key) {
        if (!screens[key]) return;
        screens[key].classList.toggle('is-active', key === name);
      });
    }

    function openModal() {
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      markSeen();
      if (tab) tab.classList.remove('is-visible');
      window.setTimeout(function () {
        if (emailInput) emailInput.focus();
      }, 50);
    }

    function closeModal() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      if (!alreadyPlayed() && tab) {
        tab.classList.add('is-visible');
      }
    }

    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeModal();
    });
    if (tab) {
      tab.addEventListener('click', openModal);
    }

    // Escape closes the modal; Tab is trapped inside it while open so
    // keyboard focus can't slip out to the page behind the overlay.
    document.addEventListener('keydown', function (e) {
      if (!overlay.classList.contains('is-open')) return;

      if (e.key === 'Escape' || e.key === 'Esc') {
        closeModal();
        return;
      }

      if (e.key === 'Tab') {
        var focusable = overlay.querySelectorAll(
          'button:not([disabled]), [href], input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];

        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });

    // Auto-trigger once per browser
    if (!hasSeen()) {
      window.setTimeout(function () {
        if (!alreadyPlayed()) openModal();
      }, TRIGGER_DELAY_MS);
    } else if (tab) {
      tab.classList.add('is-visible');
    }

    // ---- Email capture ----
    function isValidEmail(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    }

    if (emailForm) {
      emailForm.addEventListener('submit', function (e) {
        var email = (emailInput.value || '').trim();
        if (!isValidEmail(email)) {
          e.preventDefault();
          emailError.textContent = 'Enter a valid email to play.';
          emailError.classList.add('is-visible');
          return;
        }
        emailError.classList.remove('is-visible');
        // Do NOT preventDefault here: this lets the browser submit the real
        // Shopify customer form (target="bj-hidden-iframe") natively, so
        // Shopify's own hCaptcha handshake on the form runs exactly as it
        // does for a normal newsletter signup. We just move the UI forward
        // immediately rather than waiting on that request.
        showScreen('game');
        startGame();
      });
    }

    // ---- Blackjack engine ----
    var SUITS = [
      { s: '♠', red: false },
      { s: '♥', red: true },
      { s: '♦', red: true },
      { s: '♣', red: false }
    ];
    var RANKS = ['A', '2', '3', '4', '5', '6', '7', '8', '9', '10', 'J', 'Q', 'K'];

    var deck, playerHand, dealerHand, gameOver;

    function buildDeck() {
      var d = [];
      SUITS.forEach(function (suit) {
        RANKS.forEach(function (rank) {
          d.push({ rank: rank, suit: suit.s, red: suit.red });
        });
      });
      for (var i = d.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = d[i];
        d[i] = d[j];
        d[j] = tmp;
      }
      return d;
    }

    function handValue(hand) {
      var total = 0;
      var aces = 0;
      hand.forEach(function (card) {
        if (card.rank === 'A') {
          aces += 1;
          total += 11;
        } else if (card.rank === 'K' || card.rank === 'Q' || card.rank === 'J') {
          total += 10;
        } else {
          total += parseInt(card.rank, 10);
        }
      });
      while (total > 21 && aces > 0) {
        total -= 10;
        aces -= 1;
      }
      return total;
    }

    function cardEl(card, hidden) {
      var el = document.createElement('div');
      el.className = 'bj-card ' + (hidden ? 'is-hidden' : card.red ? 'is-red' : 'is-black');
      if (!hidden) {
        el.textContent = card.rank + card.suit;
      }
      return el;
    }

    function renderHands(revealDealer) {
      dealerCardsEl.innerHTML = '';
      dealerHand.forEach(function (card, idx) {
        dealerCardsEl.appendChild(cardEl(card, idx === 1 && !revealDealer));
      });
      playerCardsEl.innerHTML = '';
      playerHand.forEach(function (card) {
        playerCardsEl.appendChild(cardEl(card, false));
      });
      playerScoreEl.textContent = 'You: ' + handValue(playerHand);
      dealerScoreEl.textContent = revealDealer
        ? 'Dealer: ' + handValue(dealerHand)
        : 'Dealer: ' + handValue([dealerHand[0]]) + ' + ?';
    }

    function startGame() {
      deck = buildDeck();
      playerHand = [deck.pop(), deck.pop()];
      dealerHand = [deck.pop(), deck.pop()];
      gameOver = false;
      hitBtn.disabled = false;
      standBtn.disabled = false;
      renderHands(false);

      if (handValue(playerHand) === 21) {
        endGame('blackjack');
      }
    }

    function endGame(outcome) {
      if (gameOver) return;
      gameOver = true;
      markPlayed();
      hitBtn.disabled = true;
      standBtn.disabled = true;
      renderHands(true);

      window.setTimeout(function () {
        showScreen('result');
        var won = outcome === 'win' || outcome === 'blackjack';
        resultIcon.textContent = won ? '🎉' : '🙁';
        if (outcome === 'blackjack') {
          resultTitle.textContent = 'Blackjack! You win!';
          resultSubtitle.textContent = '21 right off the deal. Here is your code:';
        } else if (outcome === 'win') {
          resultTitle.textContent = 'You beat the dealer!';
          resultSubtitle.textContent = 'Nice hand. Here is your code:';
        } else if (outcome === 'push') {
          resultTitle.textContent = 'So close — it was a push';
          resultSubtitle.textContent = 'You tied the dealer, so no win this round. Thanks for playing!';
        } else if (outcome === 'bust') {
          resultTitle.textContent = 'Bust! Dealer wins';
          resultSubtitle.textContent = 'Over 21. Better luck next time — but you can still shop the sale.';
        } else {
          resultTitle.textContent = 'Dealer wins this round';
          resultSubtitle.textContent = 'So close! Thanks for playing.';
        }

        if (won) {
          codeBox.style.display = 'flex';
          codeText.textContent = DISCOUNT_CODE;
          shopBtn.style.display = 'inline-block';
          continueBtn.style.display = 'none';
        } else {
          codeBox.style.display = 'none';
          shopBtn.style.display = 'none';
          continueBtn.style.display = 'inline-block';
        }
      }, 900);
    }

    hitBtn.addEventListener('click', function () {
      if (gameOver) return;
      playerHand.push(deck.pop());
      var val = handValue(playerHand);
      renderHands(false);
      if (val > 21) {
        endGame('bust');
      } else if (val === 21) {
        dealerPlay();
      }
    });

    standBtn.addEventListener('click', function () {
      if (gameOver) return;
      dealerPlay();
    });

    function dealerPlay() {
      while (handValue(dealerHand) < 17) {
        dealerHand.push(deck.pop());
      }
      var playerVal = handValue(playerHand);
      var dealerVal = handValue(dealerHand);

      if (playerVal > 21) {
        endGame('bust');
      } else if (dealerVal > 21) {
        endGame('win');
      } else if (dealerVal > playerVal) {
        endGame('lose');
      } else if (dealerVal < playerVal) {
        endGame('win');
      } else {
        endGame('push');
      }
    }

    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var text = DISCOUNT_CODE;
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).then(function () {
            copyBtn.textContent = 'Copied!';
            window.setTimeout(function () {
              copyBtn.textContent = 'Copy';
            }, 1500);
          });
        }
      });
    }

    if (shopBtn) {
      shopBtn.addEventListener('click', function () {
        window.location.href = '/discount/' + DISCOUNT_CODE + '?redirect=' + SHOP_REDIRECT_PATH;
      });
    }

    if (continueBtn) {
      continueBtn.addEventListener('click', closeModal);
    }
  });
})();
